export default __webpack_public_path__ + "static/media/facebook-contact-us.3f81af6e.svg";